export default {
  methods: {
    hangup () {
      this.$sip.answeredCallSession.terminate()
    }
  }
}
